import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

import { Card, Table, Modal, Button, Spin, Popover } from 'antd';

import moment from 'moment';
import { api } from '../../../../../services';
import { pick } from 'lodash';

import './DTCsCard.css';

const serviceLevelsWithLimitedFeatures = ['light-a'];

@inject('translationsStore', 'commonStore')
@observer
export default class DTCsCard extends Component {
  constructor(props) {
    super(props);
    const { commonStore, translationsStore } = props;
    
    this.historyTableColumns = [
      {
        title: translationsStore.translate('carView.DTCsCard.history.table.columns.code'),
        dataIndex: 'code',
        sorter: true,
        sortOrder: false,
        width: 120,
        className: 'code',
        render: (text, record) => <span className={record.severity === 'red' ? 'red' : 'orange'}>{text}</span>,
      },
      {
        title: translationsStore.translate('carView.DTCsCard.history.table.columns.description'),
        dataIndex: 'description',
        sorter: true,
        sortOrder: false,
        render: (text, record) => (record.dtcTranslations.find(translation => translation.language === translationsStore.locale) || {}).description || record.description,
      },
      {
        title: translationsStore.translate('carView.DTCsCard.history.table.columns.resolvedAt'),
        dataIndex: 'resolvedAt',
        sorter: true,
        sortOrder: false,
        width: 120,
        align: 'center',
        render: text => moment(text).format(commonStore.longDateFormat.L),
      },
      {
        title: translationsStore.translate('carView.DTCsCard.history.table.columns.recordedAt'),
        dataIndex: 'recordedAt',
        sorter: true,
        sortOrder: false,
        width: 120,
        align: 'center',
        render: text => moment(text).format(commonStore.longDateFormat.L),
      },
      {
        title: translationsStore.translate('carView.DTCsCard.history.table.columns.initialOdometer'),
        dataIndex: 'initialOdometer',
        sorter: true,
        sortOrder: false,
        width: 100,
        align: 'center',
        render: text => new Intl.NumberFormat(commonStore.dateFnsLocale).format(text),
      },
      {
        title: translationsStore.translate('carView.DTCsCard.history.table.columns.km'),
        dataIndex: 'km',
        sorter: true,
        sortOrder: false,
        width: 100,
        align: 'center',
        render: text => new Intl.NumberFormat(commonStore.dateFnsLocale).format(text),
      },
    ];

    this.historyFetchMethods = [
      {
        key: 'dtcs',
        method: 'getDtcsHistory',
        defaultSorter: { field: 'resolvedAt', order: 'DESC' }
      }
    ];

    this.state = {
      sorters: { dtcs: this.historyFetchMethods[0].defaultSorter }
    };
    
    this.columns = (translate, longDateFormat, locale) => [
      {
        title: translate('carView.DTCsCard.table.columns.code'),
        dataIndex: 'code',
        width: '80px',
        className: 'code',
        render: (text, record) => {
          let style = { textDecoration: 'underline' };
          return <span className={record.severity === 'red' ? 'red' : 'orange'}><a style={style} className={record.severity === 'red' ? 'red' : 'orange'} onClick={e => {
            e.stopPropagation();
            this.showExtendedDTCs(record);
          }}>{text}</a></span>;
        }
      },
      {
        title: translate('carView.DTCsCard.table.columns.description'),
        dataIndex: 'description',
        render: (text, record) => (record.dtcTranslations.find(translation => translation.language === locale) || {}).description || record.description
      },
      {
        title: translate('carView.DTCsCard.table.columns.initialRecordedAt'),
        dataIndex: 'initialRecordedAt',
        render: text => <div>{moment(text).format(longDateFormat.L)}</div>,
        width: '100px'
      },
      {
        title: translate('carView.DTCsCard.table.columns.initialOdometer'),
        align: 'center',
        dataIndex: 'initialOdometer',
        width: '70px'
      },
      {
        title: translate('carView.DTCsCard.table.columns.km'),
        align: 'center',
        dataIndex: 'km',
        width: '70px'
      }
    ];
    this.showExtendedDTCs = record => {
      const { translationsStore } = this.props;

      return (Modal.info({
        icon: <div />,
        title: <span class="bold">{translationsStore.translate('carView.DTCsCard.extendedDescription')}</span>,
        width: 720,
        content: (
          <div>
            <p>
              <div class="bold">{translationsStore.translate('carView.DTCsCard.subcategoryDescription')}</div>
              <div dangerouslySetInnerHTML={{ __html: (((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).subcategoryDescription || '-').replaceAll("\\n","<br/>") }}></div>
            </p>
            <p>
              <div class="bold">{translationsStore.translate('carView.DTCsCard.warningDescription')}</div>
              <div dangerouslySetInnerHTML={{ __html: (((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).warningDescription || '-').replaceAll("\\n","<br/>") }}></div>
            </p>
            <p>
              <div class="bold">{translationsStore.translate('carView.DTCsCard.recommendationDescription')}</div>
              <div dangerouslySetInnerHTML={{ __html: (((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).recommendationDescription || '-').replaceAll("\\n","<br/>") }}></div>
            </p>
            <p>
              <div class="bold">{translationsStore.translate('carView.DTCsCard.causeDescription')}</div>
              <div dangerouslySetInnerHTML={{ __html: (((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).causeDescription || '-').replaceAll("\\n","<br/>") }}></div>
            </p>
            <p>
              <div class="bold">{translationsStore.translate('carView.DTCsCard.effectDescription')}</div>
              <div dangerouslySetInnerHTML={{ __html: (((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).effectDescription|| '-').replaceAll("\\n","<br/>") }}></div>
            </p>
            <p>
              <div class="bold">{translationsStore.translate('carView.DTCsCard.classification')}</div>
              <div dangerouslySetInnerHTML={{ __html: (((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).classification || '-').replaceAll("\\n","<br/>") }}></div>
            </p>
          </div>
        ),
        onOk() {},
      }));
    };
  }

  loadHistory = (methods = ['dtcs'], page = 1) => {
    const { carId } = this.props;
    
    if (!carId) {
      console.error('DTCsCard: Cannot load history without carId');
      return;
    }
    
    this.setState({
      historyLoading: true
    });
    const { sorters } = this.state;
    Promise.all(
      methods.map(method => {
        const { field: sort, order } = sorters[method];
        return api(this.historyFetchMethods.find(helper => helper.key === method).method, carId, page, sort, order);
      })
    ).then(methodsResponse => {
      const historySum = !!this.state.historySum
        ? this.state.historySum
        : methods.reduce((accumulator, method, index) => {
            return accumulator + methodsResponse[index].count;
          }, 0);
      let computedResources = methodsResponse.map((response, index) => ({
        key: methods[index],
        count: response.count,
        page,
        dataSource: response.rows.map((row, index) => ({
          ...row,
          key: index
        })),
        pagination: { total: response.count, current: page }
      }));
      let definedResources = this.state.historyResources;
      if (definedResources) {
        definedResources = definedResources.map(item => {
          const resource = computedResources.find(resource => resource.key === item.key);
          return resource ? resource : item;
        });
      } else {
        definedResources = computedResources;
      }

      const historyActiveKey = definedResources.reduce((accumulator, currentValue) => {
        return accumulator === null && methods.findIndex(method => method === currentValue.key) > -1 && currentValue.count > 0 ? currentValue.key : accumulator;
      }, null);

      let historyData = {
        historyLoading: false,
        historySum: historySum,
        historyResources: definedResources,
        historyActiveKey
      };

      if (historySum !== 0) {
        historyData = { ...historyData, historyShow: true, historyNoDataHint: false };
      } else {
        historyData = { ...historyData, historyShow: false, historyNoDataHint: true };
      }
      this.setState(historyData);
    });
  };

  handleTableChange = (key, pagination, filters, sorter) => {
    const { current: page } = pagination;
    const sorterVal = pick(sorter, ['field', 'order']);
    sorterVal.order = sorterVal.order === 'descend' ? 'DESC' : 'ASC';
    this.setState({ sorters: { ...this.state.sorters, [key]: sorterVal } }, () => {
      this.loadHistory([key], page);
    });
  };

  render() {
    const { translationsStore, commonStore } = this.props;
    const { disabled } = this.props;
    const { sorters, historyActiveKey } = this.state;
    const isDisabled = disabled || serviceLevelsWithLimitedFeatures.includes(this.props.serviceLevel);
    
    const historyColumns = this.historyTableColumns.map(column => {
      let sortOrder = (sorters[historyActiveKey] || {}).field === column.dataIndex ? sorters[historyActiveKey].order : false;
      sortOrder = sortOrder === 'DESC' ? 'descend' : sortOrder === 'ASC' ? 'ascend' : false;
      return {
        ...column,
        sortOrder
      };
    });

    return (
      <Card
        className="DTCsCard"
        style={{
          ...this.props.style,
          opacity: isDisabled ? 0.5 : 1,
          pointerEvents: isDisabled ? 'none' : 'auto',
        }}
        id="DTCsCard"
      >
        <div className="header">
          <div>{translationsStore.translate('carView.DTCsCard.title')}</div>
          {!isDisabled && (
            <Popover
              content={translationsStore.translate('carView.DTCsCard.historyNoData.message')}
              title={translationsStore.translate('carView.DTCsCard.historyNoData.title')}
              trigger="click"
              visible={this.state.historySum === 0 && this.state.historyNoDataHint}
              onVisibleChange={visible => this.setState({ historyNoDataHint: visible })}
            >
              <Button type="primary" onClick={() => this.loadHistory()}>
                {translationsStore.translate('carView.history')}
              </Button>
            </Popover>
          )}
        </div>
        <div className="container" style={{ position: 'relative' }}>
          {isDisabled && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'rgba(255,255,255,0.6)',
                zIndex: 2,
                cursor: 'not-allowed',
              }}
            />
          )}
          <Table
            rowClassName={record => (record.severity === 'red' ? 'red' : 'orange')}
            pagination={false}
            columns={this.columns(translationsStore.translate.bind(translationsStore), commonStore.longDateFormat, translationsStore.locale)}
            dataSource={this.props.dtcs}
            rowKey={record => record.id}
          />
          {!!this.props.otherdtcs && this.props.otherdtcs.length > 0 && !isDisabled && (
            <div
              onClick={() => this.setState({ showothers: true })}
              style={{
                marginTop: '10px',
                cursor: 'pointer',
                textDecoration: 'underline',
                fontWeight: 'bold',
              }}
            >
              {this.props.otherdtcs.length} {translationsStore.translate('carView.DTCsCard.otherdtcs.message')}
            </div>
          )}
        </div>
        <Modal
          title={translationsStore.translate('carView.DTCsCard.otherdtcs.title')}
          width="calc(var(--tablet-width) / var(--modal-width-ratio))"
          visible={this.state.showothers}
          getContainer={() => document.getElementById('DTCsCard')}
          footer={null}
          onCancel={() => this.setState({ showothers: false })}
          centered={true}
        >
          <Table
            rowClassName={record => (record.severity === 'red' ? 'red' : 'orange')}
            pagination={false}
            columns={this.columns(translationsStore.translate.bind(translationsStore), commonStore.longDateFormat, translationsStore.locale)}
            dataSource={this.props.otherdtcs}
            rowKey={record => record.id}
          />
        </Modal>
        <Modal
          title={translationsStore.translate('carView.DTCsCard.history.title')}
          width="calc(var(--tablet-width) / var(--modal-width-ratio))"
          visible={this.state.historyShow}
          getContainer={() => document.getElementById('DTCsCard')}
          footer={null}
          onCancel={() => this.setState({ historyShow: false })}
          centered={true}
        >
          <Spin spinning={this.state.historyLoading}>
            {(this.state.historyResources || []).map(
              (item, index) =>
                item.count > 0 &&
                item.key === this.state.historyActiveKey && (
                  <Table
                    key={index}
                    dataSource={this.state.historyResources[index] && this.state.historyResources[index].dataSource}
                    columns={historyColumns}
                    pagination={item.pagination}
                    onChange={(...params) => this.handleTableChange(item.key, ...params)}
                    rowKey={record => record.id}
                    scroll={{ x: 'max-content' }}
                  />
                )
            )}
          </Spin>
        </Modal>
      </Card>
    );
  }
}
